import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd3b65c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alerta"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.erroGerarRespostas)
      ? (_openBlock(), _createElementBlock("article", _hoisted_1, _toDisplayString(_ctx.erroGerarRespostas), 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gerar && _ctx.gerar(...args)))
    }, "Gerar Relatório")
  ], 64))
}